import React, {useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import useMainSlider from "./useMainSlider";

export default function () {
  const {reset, handleSubmit, setErrors, mainSliderFields} = useMainSlider();
  const {id} = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`main-sliders/${id}/edit`).then(res => {
      reset(res.data.mainSlider);
    });
  }, []);

  const editSlider = data => {
    let formData = new FormData();

    Object.entries(data).forEach(([property, value]) => {
      formData.append(`${property}`, value || '');
    });

    formData.append('_method', 'PUT');

    axios.post(`main-sliders/${id}`, formData).then(function (res) {
      navigate('/main-sliders');
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      }
    });
  }

  return (
    <Card title="Edit slider">
      <form className="form w-100 row" onSubmit={handleSubmit(editSlider)}>
        {mainSliderFields}
        <div className="col-12">
          <SubmitButton title="Update" classes="d-inline-block w-auto"/>
        </div>
      </form>
    </Card>
  );
}